import {usePlaneduHttpService} from "../service/planedu.http.service";
import {ResetPasswordProfileEntity} from "../entity/reset-password-profile";

export function useResetPasswordProfileService() {
    const httpService = usePlaneduHttpService<ResetPasswordProfileEntity>('users/reset-password');
    return {
        ...httpService,
    }
}
